import {
  downloadGoDoDesktopInstall,
  type LocalEngineInstallOptions,
} from "./godo-local-engine-installer";
import { stashZktecoPairingCode } from "./zkteco-pending-pair";

let wizardListener: (() => void) | null = null;

export function registerDesktopInstallWizard(open: () => void) {
  wizardListener = open;
  return () => {
    if (wizardListener === open) wizardListener = null;
  };
}

/** Fetches NSSM install script from API (short-lived token) + opens wizard. */
export async function startGoDoDesktopInstall(
  appOrigin: string = window.location.origin,
  options: LocalEngineInstallOptions = {},
) {
  if (options.pairingCode?.trim()) {
    stashZktecoPairingCode(options.pairingCode);
  }
  await downloadGoDoDesktopInstall(appOrigin, options);
  wizardListener?.();
}
